module.exports = __webpack_public_path__ + "h5/img/bg_upload_by_link_1.afb08070.afb08070.png";